import React from 'react';

const ImageSharpenIcon = () => {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Image-Splitting" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Missing-Image-Match---Image-Edit-Tooltip" transform="translate(-372.000000, -1115.000000)" fill="#262aff">
          <g id="Edit-Toolbar" transform="translate(283.000000, 1104.000000)">
            <g id="Sharpen" transform="translate(78.000000, 0.000000)">
              <polygon id="Triangle" points="20 11 29 29 11 29" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ImageSharpenIcon;
